import store from './../store'
import router from './../router'
import popup from './popup.helper'

class Http {
  constructor () {
    //
    this.debug = true
  }

  init (http) {
    this.http = http

    this.http.interceptors.push((request, next) => {
      next((response) => {
        if (response.status === 401) {
          store.dispatch('logout')
          router.push('/login')
        }
      })
    })
  }

  get (...args) {
    return this.request('get', ...args)
  }

  post (...args) {
    return this.request('post', ...args)
  }

  put (...args) {
    return this.request('put', ...args)
  }

  patch (...args) {
    return this.request('patch', ...args)
  }

  delete (...args) {
    return this.request('delete', ...args)
  }

  request (method, url, data, successCallback, errorCallback) {
    let promise = this.http[method](url, data)
      .then(response => {
        if (typeof successCallback === 'function') {
          successCallback(response.data, response)
        }
      })

    if (typeof errorCallback === 'undefined') {
      return promise.catch(this.errorHandler)
    } else {
      return promise.catch(error => {
        if (!error.status || error.status === 500) {
          if (errorCallback) {
            errorCallback(error)
          } else {
            this.errorHandler(error)
          }
        } else {
          errorCallback(error)
        }
      })
    }
  }

  errorHandler (error) {
    console.log(error)
    popup.error('Server returned unexpected result', 'Request failed')
  }
}

const http = new Http()
export default http
